<template>
<el-dialog title="审核确认" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
    <el-form :model="query" ref="grantForm" label-width="100px" label-position="left">
        <h3>对当前的客资申请的结果是：</h3>
        <el-radio-group v-model="query.audit_id" class="radio-group">
            <el-radio label="2">审核通过</el-radio>
            <el-radio label="3">驳回申请</el-radio>
        </el-radio-group>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
    </span>
</el-dialog>
</template>

<script>
const query = {
    audit_id: "",
};
export default {
    props: {
        parent: {}
    },
    data() {
        return {
            query: Object.assign({}, query), // 搜索条件
            dialogVisible: false,
            allocateForm: {
                ids: []
            }
        };
    },
    methods: {
        handleClose(done) {
            this.dialogVisible = false
        },
        showDialog(query, type) {
            let _this = this;
            _this.query = Object.assign({}, _this.query);
            _this.query.audit_id = '';
            this.allocateForm.ids = query.ids;
            this.dialogVisible = true
        },
        showRowlog(query, type) {
            let _this = this;
            _this.query.audit_id = '';
            //字符串转数组
            let str = (query.id).toString()
            let arr = str.split(",").map(Number);

            this.allocateForm.ids = arr;
            this.dialogVisible = true
        },
        submit() {
            let _this = this;
            let url = '/api/merchant.apply/check';
            let data = {
                ids: _this.allocateForm.ids,
                apply_status: _this.query.audit_id,
            };
            _this.$post(url, data).then((res) => {
                if (res.code == 200) {
                    _this.$message({
                        type: 'success',
                        message: res.msg,
                        showClose: true
                    });
                    _this.dialogVisible = false
                    _this.parent.getTableData();
                } else {
                    _this.$message.error(res.msg);
                }
            });
        }
    }
};
</script>
